export { Hero } from './Hero';
export { FAQ } from './FAQ';
export { FreshBenefits } from './FreshBenefits';
export { HowTo } from './HowTo';
export { FreshUpsell } from 'src/pages/Signup/DIY/components/FreshUpsell';
export { VitalMix } from './VitalMix';
export { Recipes } from './Recipes';
